(function ($, scsHeaderJQuery, scsHeader, SCS) {
	'use strict';

	SCS.ecommerce = SCS.ecommerce || {};

	SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION = 503;

	SCS.ecommerce.MESSAGE_TYPE_UNAVAILABLE = 'UNAVAILABLE';

	/**
	 * Call to eCommerce with success/error callbacks.
	 *
	 * The config object is similar to the jQuery.ajax config object.
	 * You can define type (GET or POST), url, data (name/value pairs), success and error callback functions
	 * (or omit any of them, except url).
	 * The callbackObj is for executing the callback functions on (for "this").
	 * @param config Configuration (type, url, data, success, error)
	 * @param callbackObj Callback object ("this" in the callback function)
	 */
	SCS.ecommerce.eCommerceCall = function (config, callbackObj) {
		if (callbackObj === undefined) {
			callbackObj = this;
		}
		config = $.extend({type: 'GET', data: null}, config);
		$.ajax({
			type: config.type,
			url: config.url,
			data: config.data,
			success: function (data) {
				if (data && data.Error) {
					if (data.Error.Code === 'OK') {
						callbackObj._success = config.success;
						callbackObj._success();
					}
					else {
						callbackObj._error = config.error;
						callbackObj._error(data.Error.Messages);
					}
				}
				else {
					callbackObj._error = config.error;
					callbackObj._error(null);
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				if (config.error) {
					callbackObj._error = config.error;
					callbackObj._error(errorThrown);
				}
				else {
					if (xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
						SCS.ecommerce.showEcommerceErrorMessage();
					} else {
						SCS.portal.showError();
					}
				}
			}
		});
	};

	/**
	 * Set cookie for all language paths.
	 * Reason: For some strange reason, you can set a cookie on '/' but then later not read it in JavaScript.
	 * At least not on INT1. With deeper paths it works.
	 * @param name Name
	 * @param value Value
	 */
	SCS.ecommerce.setCookieForAllLanguages = function (name, value, expires) {
		var paths = ['/', '/de', '/en', '/fr', '/it'];
		for (var i = 0; i < paths.length; i += 1) {
			scsHeaderJQuery.cookie(name, value, {expires: expires, path: paths[i]});
		}
	};

	/**
	 * Set redirect cookie
	 */
	SCS.ecommerce.setRedirectCookie = function (url) {
		this.setCookieForAllLanguages('SCS_REDIRECT', url);
	};

	/**
	 * Initialize redirect. If the redirect-cookie is present,
	 * this will auto-redirect there (and delete the cookie before that).
	 */
	SCS.ecommerce.initRedirect = function () {
		var url = scsHeaderJQuery.cookie('SCS_REDIRECT');
		if (url) {
			this.setCookieForAllLanguages('SCS_REDIRECT', null);
		}
	};

	/**
	 * find teasers in different containers an synchronize their heights (based on sub-containers)
	 * (by default all predefined teasers are synched BUT one can define two parameters to only synch specific teasers)
	 */
	SCS.ecommerce.synchronizeTeaserHeights = function (containerSelector, teaserSelector, scope) {
		if (!SCS.portal.synchronizeTeaserHeights) {
			return; // no syncing for mobile version
		}

		if (containerSelector && teaserSelector && containerSelector.length && teaserSelector.length) {
			SCS.portal.synchronizeTeaserHeights(containerSelector, teaserSelector, scope);
		}
	};

	/**
	 * Initialize common stuff
	 */
	$(document).ready(function () {
		SCS.ecommerce.initRedirect();
		$(window).on('load', SCS.ecommerce.synchronizeTeaserHeights);
		$(window).on('load', SCS.ecommerce.synchronizePricePaddings);
	});

	SCS.ecommerce.synchronizePricePaddings = function () {
		var height = 0,
			teasers = $('.abos .scs-abo-teaser .custom-radio'),
			hidePanel = false;

		if (teasers.parents('.ui-tabs-panel:hidden').length) {
			hidePanel = true;
			teasers.parents('.ui-tabs-panel').removeClass('ui-tabs-hide');
		}

		teasers.each(function () {
			var $this = $(this);
			height = Math.max(height, $this.height(), $this.css('height', '').height());
		});

		teasers.each(function () {
			var $this = $(this),
				compareHeight = Math.max($this.height(), $this.css('height', '').height());
			if (compareHeight < height) {
				var currentPadding = $this.css('paddingTop').replace('px', '');
				var paddingTop = height - compareHeight + parseInt(currentPadding, 10);
				$this.css('paddingTop', paddingTop + 'px');
			}
		});

		if (hidePanel) {
			teasers.parents('.ui-tabs-panel').addClass('ui-tabs-hide');
		}
	};

	SCS.ecommerce.MESSAGES_CONFIG_RES_URL = '/bin/scs/services/ecommercemessages.keyvalues';
	SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_TITLE = 'ecommerce.service.unavailable.title';
	SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_MESSAGE = 'ecommerce.service.unavailable.message';

	SCS.ecommerce.showEcommerceErrorMessage = function () {
		function findEcommerceMessageValue(msgConfig, configKey) {
			for (var child in msgConfig) {
				if (msgConfig[child].configKey === configKey) {
					return msgConfig[child].configValue;
				}
			}
		}
		$.ajax({
			url: SCS.ecommerce.MESSAGES_CONFIG_RES_URL + '.' + SCS.portal.lang + '.json',
			success: function (configJson) {
				var ecommerceTitle = findEcommerceMessageValue(configJson, SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_TITLE),
					ecommerceMessage = findEcommerceMessageValue(configJson, SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_MESSAGE);

				$('<div/>').html(ecommerceMessage).dialog({
					title: ecommerceTitle,
					classes: {'ui-dialog': 'warn'},
					close: function () {
						history.back();
					}
				});
			}
		});
	};

})(window.$, window.scsHeaderJQuery, window.scsHeader, window.SCS = window.SCS || {});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/common.js
// module id = 245
// module chunks = 0